import { render, staticRenderFns } from "./CameraRelieveIcon.vue?vue&type=template&id=66bad98a&scoped=true"
import script from "./CameraRelieveIcon.vue?vue&type=script&lang=js"
export * from "./CameraRelieveIcon.vue?vue&type=script&lang=js"
import style0 from "./CameraRelieveIcon.vue?vue&type=style&index=0&id=66bad98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bad98a",
  null
  
)

export default component.exports